export enum TimeUnits {
    Minuts = 0,
    Hour = 1,
    Day = 2,
    Month = 3,
}
